import styled from 'astroturf/react';

const Wrapper = styled('div')`
  position: absolute;
  background-color: var(--black);
  bottom: -160px;
  height: 150px;
  left: calc(50% - 75px);
  width: 150px;
  z-index: 100;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: calc(50% - 3px);
    top: -7px;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid var(--black);
  }
`;

const Scrollable = styled('div')`
  overflow-y: auto;
  height: 100%;
`;

const Item = styled('div')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: normal;
  color: var(--white);
  padding: 5px 15px;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background-color: rgba(var(--ph-gray-rgb-500), 0.2);
    font-weight: bold;
  }
`;

export default {
  Wrapper,
  Scrollable,
  Item,
};
